<template>
  <Teleport to="#modals">
    <div ref="modal" class="modal fade" v-bind="$attrs" :data-bs-backdrop="backdrop ? 'static' : false" :data-bs-keyboard="keyboard" :data-bs-focus="focus" tabindex="-1" aria-hidden="true" style="user-select:none;">
      <div class="modal-dialog" :class="modalSize">
        <div ref="modalContent" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="btn-close" @click="hide()"></button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
                <button type="button" class="btn btn-primary" @click="hide()">Tamam</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';
import { Modal } from "bootstrap";
import { appData } from '@/helpers/global';

export default {
    name: "SmartModal",
    inheritAttrs: false,
    props: {
        title: String,
        backdrop: {
            type: Boolean,
            default: true,
        },
        keyboard: {
            type: Boolean,
            default: false,
        },
        focus: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default: "modal-dialog-centered modal-dialog-scrollable modal-fullscreen-md-down",
        },
     }, 
    setup(props, { expose }) {
        const modalSize = ref(props.size);
        const modal = ref(null);
        const modalContent = ref(null);
        let modalInstance = null;
        onMounted(() => {
            modalInstance = new Modal(modal.value, {
                backdrop: 'static',
                keyboard: false
            });
        });
        onBeforeUnmount(() => {
            if (modalInstance) {
                modalInstance.dispose();
            }
        });
        const show = () => {
            try {
                if (modalInstance) {
                    modalInstance.show();
                }
            }
            catch (ex) { console.warn(ex.message); }
        };
        const hide = () => {
            try {
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
            catch (ex) { console.warn(ex.message); }
        };
        const scrollTop = (top) => {
            if (modalContent.value) {
                nextTick(() => {
                    const body = modalContent.value.querySelector(".modal-body");
                    if (body) {
                        appData.fn.scrollStart(body, top);
                    }
                });
            }
        };
        expose({ modalContent, show, hide, scrollTop });

        watch(() => props.size, (n, o) => {
            if (n != o) {
                modalSize.value = n;
            }
        }, { deep: true });
        return { modal, modalContent, show, hide, scrollTop, modalSize };
    }
};
</script>
